module.exports = __webpack_public_path__ + "8576e38c335d4ebebfd176772e78b5b0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Pachantiew/10.jpg
// module id = 1336
// module chunks = 47